import React, { ReactNode } from 'react';

import { Typography } from '@mui/material';

import * as Styled from './styled';

interface PropsType {
	children?: ReactNode;
	title?: string;
}

function ProfileInfoBlockListBlock({ children, title }: PropsType) {
	return (
		<Styled.Wrap>
			{title && (
				<Styled.TitleWrap elevation={2}>
					<Typography variant="h4" color="primary">
						{title}
					</Typography>
				</Styled.TitleWrap>
			)}
			{children}
		</Styled.Wrap>
	);
}

export default ProfileInfoBlockListBlock;
